import { defaultEquipmentIds } from '../data/equipment';
import { todayIso } from '../lib/dates';
import { DEFAULT_ENDPOINT } from '../lib/health';
import { STATE_VERSION, type AppState } from './types';

/**
 * Neutral starting state.
 *
 * These are placeholders, not a person. The first-run setup replaces them with
 * your real numbers — which matters because height and weight drive the calorie
 * targets, and a guessed height quietly skews every figure on the Progress
 * screen. Keeping the defaults impersonal also means the deployed JavaScript
 * carries nobody's stats.
 *
 * The schedule defaults to lifting Mon/Wed/Fri with cardio Tue/Thu, which is
 * the most common arrangement and the one the splits are tuned around.
 */
export function defaultState(): AppState {
  return {
    version: STATE_VERSION,
    profile: {
      name: '',
      age: 25,
      heightCm: 178,
      bodyweightKg: 80,
      sex: 'male',
      goal: 'recomp',
      activityLevel: 'moderate',
      liftDays: [1, 3, 5],
      cardioDays: [2, 4],
      gymTime: '18:00',
      remindersEnabled: false,
      reminderLeadMinutes: 60,
    },
    settings: {
      splitMode: 'auto',
      blockLengthWeeks: 4,
      deloadEveryNBlocks: 2,
      equipment: defaultEquipmentIds(),
      programStartDate: todayIso(),
      showImages: true,
      useSupersets: true,
      onboarded: false,
      health: {
        enabled: false,
        endpoint: DEFAULT_ENDPOINT,
        token: '',
        autoImportWorkouts: true,
      },
    },
    workouts: [],
    cardio: [],
    metrics: [],
    activeWorkout: null,
    exercisePrefs: { favorites: [], excluded: [] },
    healthDays: [],
    importedWorkoutIds: [],
  };
}
